import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-800 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8 flex flex-wrap items-center justify-between gap-4 text-xs text-zinc-500">
        <span>&copy; {new Date().getFullYear()} Promptbound</span>
        <nav className="flex flex-wrap gap-x-6 gap-y-2">
          <span className="text-zinc-600 uppercase tracking-[0.15em] text-[10px] font-semibold">Resources</span>
          <Link to="/interview-query-alternatives" className="hover:text-zinc-300">Interview Query alternatives</Link>
          <Link to="/best-ai-engineer-interview-prep-platforms" className="hover:text-zinc-300">Best AI engineer interview prep platforms</Link>
        </nav>
      </div>
    </footer>
  );
}
